module.exports = __webpack_public_path__ + "img/img_01.3a0552d7.jpg";